import React, { useEffect, useState, useRef } from 'react';
import Card from './Common/Card';
import SectionTitle from './Common/SectionTitle';

const Achievements = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const achievements = [
    {
      id: 1,
      title: "Academic Excellence Award",
      description: "Recognizing outstanding academic performance",
      imageUrl: "https://lh3.googleusercontent.com/pw/AP1GczMWInsa0fLDzIepaUu3gQKh-MpsjrzCS4ClfnK8D9jwwAP9VIK8aHyScdpfQ916NCCN4zXG9TUAS5X-PjMbFnwOxTCFbfj-gGamg2Q2b4BJ1N_l-0fpGWf4DsmPAwOM2UCFZ7qlQ3YY9CM5nSTKdJuv=w1600-h694-s-no-gm?authuser=0"
    },
    {
      id: 2,
      title: "Inter-School Music Championship",
      description: "Celebrating victory in the music competition",
      imageUrl: "https://lh3.googleusercontent.com/pw/AP1GczMQyUjbzKjR4ElwDpe3ARugYcdchsEKTcTgDmADSBzxBS3AgDLb9FlyOeuEYV7nEKAg4783Z84k3gLhJqawUgY2jcNjuu895O9qEnnx36qtKFwAGFOvPj0XRTbTixcalZjKO0qMJlbeFQsajah3i88H=w617-h827-s-no-gm?authuser=0"
    },
    {
      id: 3,
      title: "Annual Sports Day",
      description: "Highlights from our annual sports event",
      imageUrl: "https://lh3.googleusercontent.com/pw/AP1GczN_DFX0rxrLBGf9US8koZuxOZRgBeMfDzSlHANt3m2Y-6BwonPkyicCbeGqwEMM22Cqtg4fUFnQvPRE0tCh8mlOQdxlW6duYhMcjdXgU9_uaw1SPu8XJXJBAjPqMxYGIPqUZYFpZ-rGHtIUOzCW4Jvt=w1470-h827-s-no-gm?authuser=0"
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="mb-16">
      <div className={`transition-all duration-1000 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <SectionTitle>Achievements & Awards</SectionTitle>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {achievements.map((achievement, index) => (
          <div
            key={achievement.id}
            className={`transition-all duration-700 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ transitionDelay: `${index * 200}ms` }}
          >
            <Card hover className="group overflow-hidden rounded-xl shadow-lg dark:shadow-gray-800">
              <div className="relative w-full h-48 overflow-hidden rounded-t-xl">
                <div 
                  className="w-full h-full bg-center bg-cover transition-transform duration-500 group-hover:scale-110"
                  style={{ backgroundImage: `url("${achievement.imageUrl}")` }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none rounded-t-xl"></div>
              </div>
              <div className="p-4">
                <p className="text-lg md:text-xl font-semibold text-slate-900 dark:text-white transition-colors duration-300 group-hover:text-primary">
                  {achievement.title}
                </p>
                <p className="text-sm md:text-base text-slate-500 dark:text-slate-400">
                  {achievement.description}
                </p>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Achievements;
